var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EE741F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8006 16.8815C49.6622 16.8815 50.3606 17.5799 50.3606 18.4415V26.824C50.3606 27.6855 49.6622 28.384 48.8006 28.384H40.4181C39.5565 28.384 38.8581 27.6855 38.8581 26.824C38.8581 25.9624 39.5565 25.264 40.4181 25.264H47.2406V18.4415C47.2406 17.5799 47.9391 16.8815 48.8006 16.8815Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0006 17.9598C30.1879 17.9598 28.393 18.3172 26.7186 19.0115C25.0441 19.7058 23.523 20.7234 22.2421 22.0061C21.6334 22.6158 20.6456 22.6165 20.036 22.0077C19.4263 21.3989 19.4256 20.4112 20.0344 19.8015C21.605 18.2286 23.4703 16.9808 25.5235 16.1294C27.5768 15.2781 29.7778 14.8398 32.0006 14.8398C34.2234 14.8398 36.4244 15.2781 38.4777 16.1294C40.5305 16.9806 42.3954 18.228 43.9657 19.8004C43.9661 19.8008 43.9654 19.8 43.9657 19.8004L49.9021 25.7193C50.5122 26.3276 50.5136 27.3153 49.9053 27.9255C49.297 28.5356 48.3093 28.537 47.6992 27.9287L41.7615 22.0085L41.7591 22.0061C40.4783 20.7234 38.9571 19.7058 37.2827 19.0115C35.6082 18.3172 33.8133 17.9598 32.0006 17.9598Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6406 36.7084C13.6406 35.8468 14.3391 35.1484 15.2006 35.1484H23.5832C24.4447 35.1484 25.1432 35.8468 25.1432 36.7084C25.1432 37.57 24.4447 38.2684 23.5832 38.2684H16.7606V45.0909C16.7606 45.9525 16.0622 46.6509 15.2006 46.6509C14.3391 46.6509 13.6406 45.9525 13.6406 45.0909V36.7084Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0959 35.6069C14.7042 34.9968 15.692 34.9954 16.3021 35.6037L22.2421 41.5263C23.523 42.809 25.0441 43.8266 26.7186 44.5209C28.393 45.2152 30.1879 45.5725 32.0006 45.5725C33.8133 45.5725 35.6082 45.2152 37.2827 44.5209C38.9571 43.8266 40.4783 42.809 41.7591 41.5263C42.3679 40.9166 43.3556 40.9159 43.9653 41.5247C44.5749 42.1334 44.5756 43.1212 43.9669 43.7308C42.3963 45.3037 40.531 46.5516 38.4777 47.4029C36.4244 48.2543 34.2234 48.6925 32.0006 48.6925C29.7778 48.6925 27.5768 48.2543 25.5235 47.4029C23.4708 46.5518 21.6059 45.3043 20.0355 43.732C20.0351 43.7316 20.0359 43.7323 20.0355 43.732L14.0992 37.8131C13.489 37.2048 13.4876 36.217 14.0959 35.6069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeProcessing);
export default __webpack_public_path__ + "static/media/orange-processing.0f93d5b9f598fe7742a5b5549ce8c66e.svg";
export { ForwardRef as ReactComponent };